const pressImageUrls = [
  {
    url: 'press/racked.png',
    width: '93%'
  },
  {
    url: 'press/techcrunch.png',
    width: '42%'
  },
  {
    url: 'press/elle.png',
    width: '68%'
  },
  {
    url: 'press/silicon_valley_biz_journal.png',
    width: '93%'
  },
  {
    url: 'press/abc.png',
    width: '52%'
  },
  {
    url: 'press/glamour.png',
    width: '68%'
  }
];

export default pressImageUrls;
